import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components/macro';
import MobileHeaderComponent from '../HeaderComponent/MobileHeaderComponent';
import FooterComponent from '../FooterComponent/FooterComponent';
import MobileConfirmationComponent from '../ConfirmationComponent/MobileConfirmationComponent.js';
import DividerComponent from '../DividerComponent/DividerComponent';
import configs from '../../configuration/configuration.json';
import { ThemeContext } from 'styled-components';
import RegistrationPrimaryFormContainer from '../../containers/RegistrationPrimaryFormContainer/RegistrationPrimaryFormContainer';
import RegistrationSecondaryFormContainer from '../../containers/RegistrationSecondaryFormContainer/RegistrationSecondayFormContainer';
import RegistrationOverviewContainer from '../../containers/RegistrationOverviewContainer/RegistrationOverviewContainer';
import { PinDropRounded } from '@material-ui/icons';

const imgBasePath = process.env.REACT_APP_env_img_base_path;

const StyledRoot = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
`;

const HeaderBox = styled.div`
  background-color: ${ props => props.theme.regBgColor };
  display: flex;
  flex-direction: column;
  padding-bottom: 2em;
  text-align: center;
  color: white;
  position: relative;
  left: 0;
  z-index: 1;
  padding-top: 1em;
`;

const RegHeaderText = styled.h1`
  margin-bottom: .3em;
  color: ${ props => props.theme.mainText };
`;

const RegHeaderSubtext = styled.p`
  font-size: 1.5em;
  width: 100%;
  margin-bottom: 1em;
  text-align: center;
  color: ${ props => props.theme.mainText };
`;

const RegBlurbText = styled.p`
  color: ${ props => props.theme.mainText };
`;

const RegBlurb = styled.div`
  margin-top: .3em;
  width: 100%;
  padding-left: 10%;
  padding-right: 10%;
`;

const CardContainerTitle = styled.p`
  font-size: .8em;
  font-weight: 400;
  height: 1em;
  width: 30em;
  align-self: center;
  text-align: center;
  letter-spacing: .1em;
  color: ${ props => props.theme.mainText };
`;

const CardsContainer = styled.div`
  margin-bottom: 2em;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const RegCard = styled.div`
  margin-bottom: 1em;
  width: 90%;
  padding: 2em;
  border-style: solid;
  border-width: 1px;
  border-radius: 10px;
  border-color: ${ props => props.theme.regCardBorderColor };
`;

const CardTitle = styled.p`
  color: ${ props => props.theme.mainText };
`;

const CardImage = styled.img`
  height: 6em;
`;

const CardHeader = styled.h1`
  font-size: 2.2em;
  font-weight: 400;
  color: ${ props => props.theme.mainText };
`;

const CardText = styled.p`
  font-size: 1.2em;
  font-weight: 400;
  color: ${ props => props.theme.mainText };
`;

const FormInstructionWrapper = styled.ol`
  width: 90%;
  margin-bottom: 1em;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
`;

const InstructionListWrapper = styled.ol`
  align-self: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: left;
  padding-left: 1em;
`;

const FormInstructionTitle = styled.p`
  color: ${props => props.theme.primaryText};
`;

const StyledListItem = styled.li`
  display: list-item;
  flex-direction: column;
  width: 100%;
  margin-bottom: 2em;
  font-size: 1.3em;
  font-weight: 400;
  letter-spacing: 0px;
  color: ${props => props.theme.primaryText};
  align-items: left; 
`;

const FormInstructionText = styled.p`
  font-size: 1.3em;
  width: 100%;
  color: ${ props => props.theme.mainText };
`;

const StyledWrapper = styled.div`
  display: flex;
  background-color: ${props => props.theme.card};
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
`;

const TemplatedHeaderbox = styled.div`
  background: ${props => props.theme.registrationHeaderBackground};
  display: flex;
  flex-direction: column;
  padding-bottom: 2em;
  justify-content: left;
  color: white;
  position: relative;
  left: 0;
  z-index: 1;
  padding-top: 1em;
`;

const PoweredByCatalyteContainer = styled.div`
  width: 100%;
  height: 2em;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: left;
`;

const CreateOpportunityLogoContainer = styled.img`
  width: 50%;
  height: 3em;
  margin-top: 7%;
  margin-left: 1.75em;
`;

const PoweredByText = styled.p`
  width: 6em;
  font-size: 12px;
  margin-left: 2.5em;
`;

const CatalyteLogoContainer = styled.img`
  width: 4em;
  height: 1.25em;
  margin-top: 2.2%;
`;

const MobileRegistrationComponent = (props) =>{
    const themeContext = useContext(ThemeContext);
    const [global, setGlobal] = useState(props.globalState);
    const config = useSelector(state => state.global && state.global.config || {"name": "default"})
    let childProps = {...props, themeContext};

    useEffect(() => {
      setGlobal(props.globalState);
    }, [props.globalState])

    const renderHeaderBox = function(){
      if(props.client === 'createoppcolumbia'){
        return(
          <TemplatedHeaderbox>
            <CreateOpportunityLogoContainer src={imgBasePath + 'create-op-logo.png'} />
            <PoweredByCatalyteContainer>
              <PoweredByText>Powered by</PoweredByText>
              <CatalyteLogoContainer src={imgBasePath + 'catalyte_white_logo_transparent.png'} />
            </PoweredByCatalyteContainer>
          </TemplatedHeaderbox>
        )
      }else{
        return(
          <HeaderBox>
            <RegHeaderText>{headerText}</RegHeaderText>
            <RegHeaderSubtext>{headerSubtext}</RegHeaderSubtext>
            <DividerComponent/>
            <RegBlurb>
              <RegBlurbText dangerouslySetInnerHTML={{__html: blurbText}}></RegBlurbText>
            </RegBlurb>
            <CardContainerTitle>{config.registration.primary.cardContainerTitle}</CardContainerTitle>
            <CardsContainer>
              {config.registration.primary.regCardImgUrl1 &&
              <RegCard>
                <CardTitle>{config.registration.primary.regCardTitle1}</CardTitle>
                <CardImage src={imgBasePath + config.registration.primary.regCardImgUrl1}></CardImage>
                <CardHeader>{config.registration.primary.regCardHeader1}</CardHeader>
                <CardText>{config.registration.primary.regCardText1}</CardText>
              </RegCard>
              }
              {config.registration.primary.regCardImgUrl2 &&
              <RegCard>
                <CardTitle>{config.registration.primary.regCardTitle2}</CardTitle>
                <CardImage src={imgBasePath + config.registration.primary.regCardImgUrl2}></CardImage>
                <CardHeader>{config.registration.primary.regCardHeader2}</CardHeader>
                <CardText>{config.registration.primary.regCardText2}</CardText>
              </RegCard>
              }
              {config.registration.primary.regCardImgUrl3 &&
              <RegCard>
                <CardTitle>{config.registration.primary.regCardTitle3}</CardTitle>
                <CardImage src={imgBasePath + config.registration.primary.regCardImgUrl3}></CardImage>
                <CardHeader>{config.registration.primary.regCardHeader3}</CardHeader>
                <CardText>{config.registration.primary.regCardText3}</CardText>
              </RegCard>
              }
            </CardsContainer>
            <FormInstructionWrapper>
              <FormInstructionTitle>{config.registration.primary.instructionTitle}</FormInstructionTitle>
              <DividerComponent/>
              <InstructionListWrapper>
              {
              (config.registration.primary.instructionBullets) &&
              renderListitems(config.registration.primary.instructionBullets)
              }
              </InstructionListWrapper>
              <FormInstructionText dangerouslySetInnerHTML={{__html: config.registration.primary.instructionText}}></FormInstructionText>
            </FormInstructionWrapper>
          </HeaderBox>
        )
      }
    }
    
    const renderForm = function(form){
      switch(form){
        case "overview": return(
          <RegistrationOverviewContainer {...childProps} />
        )
        case "primary": return(
          <RegistrationPrimaryFormContainer {...childProps} />
        )
        case "secondary": return(
          <RegistrationSecondaryFormContainer {...childProps} />
        )
        case "confirmation": return(
          <MobileConfirmationComponent {...childProps} />
        )
        default:
          return (
            <RegistrationPrimaryFormContainer {...childProps} />
        )
      }
    }

    const renderListitems = (items) => {
      return items.map((v, i) => {
        return  <StyledListItem key={i} dangerouslySetInnerHTML={{__html: v}}></StyledListItem>
      })
    }

    const registrationConfig = props.globalState.config && props.globalState.config.registration || {"confirmation": {}, "primary": {}};

    const headerText = props.currentForm === 'confirmation' ? registrationConfig.confirmation.header : registrationConfig.primary.header;
    const headerSubtext = props.currentForm === 'confirmation' ? registrationConfig.confirmation.subHeader : registrationConfig.primary.subHeader;
    const blurbText = props.currentForm === 'confirmation' ? registrationConfig.confirmation.blurb : registrationConfig.primary.blurb;
    const imgBasePath = process.env.REACT_APP_env_img_base_path;

    return (
      <StyledRoot>
        <MobileHeaderComponent logoImageUrl={imgBasePath + props.globalState.config.logo} showLogin={!global.cognitoUser} showLogout={global.cognitoUser} username={global.cognitoUser && global.cognitoUser.username}/>
        <StyledWrapper>
          { renderHeaderBox() }
          { renderForm(props.currentForm) }
        </StyledWrapper>
        <FooterComponent showLogin={!global.cognitoUser} showLogout={global.cognitoUser} />
      </StyledRoot>
    );
  }

export default MobileRegistrationComponent;
